<template>
  <v-container fluid class="intelligence-people pa-4">
    <v-row>
      <v-col cols="12">
        <h1 class="text-h5 font-weight-bold mb-1 theme-heading">
          People
        </h1>
        <p class="text-subtitle-2 grey--text text--darken-1 mb-4">
          Browse talent profiles and explore your organizational structure
        </p>
      </v-col>
    </v-row>

    <v-tabs v-model="activeTab" color="primary" class="mb-6" @change="onTabChange">
      <v-tab>
        <v-icon small class="mr-2">mdi-account-group</v-icon>
        Directory
      </v-tab>
      <v-tab>
        <v-icon small class="mr-2">mdi-sitemap</v-icon>
        Org Chart
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <intelligence-profiles :embedded="true" />
      </v-tab-item>
      <v-tab-item>
        <intelligence-org-hierarchy :embedded="true" />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import IntelligenceProfiles from "./IntelligenceProfiles.vue";
import IntelligenceOrgHierarchy from "./IntelligenceOrgHierarchy.vue";

const TAB_MAP = { directory: 0, orgchart: 1 };
const TAB_NAMES = ["directory", "orgchart"];

export default {
  name: "IntelligencePeople",
  components: { IntelligenceProfiles, IntelligenceOrgHierarchy },
  data() {
    return {
      activeTab: 0,
    };
  },
  created() {
    const tab = (this.$route.query.tab || "").toLowerCase();
    if (TAB_MAP[tab] !== undefined) {
      this.activeTab = TAB_MAP[tab];
    }
  },
  methods: {
    onTabChange(index) {
      const tabName = TAB_NAMES[index];
      if (this.$route.query.tab !== tabName) {
        this.$router.replace({ query: { ...this.$route.query, tab: tabName } }).catch(() => {});
      }
    },
  },
  watch: {
    "$route.query.tab"(newTab) {
      const tab = (newTab || "").toLowerCase();
      if (TAB_MAP[tab] !== undefined && this.activeTab !== TAB_MAP[tab]) {
        this.activeTab = TAB_MAP[tab];
      }
    },
  },
};
</script>

<style scoped>
.intelligence-people {
  max-width: 1400px;
}
</style>
